module.exports = __webpack_public_path__ + "img/V-L-2-unload-standup-shadow.98ce4028.png";